var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-center":""}},[_c('h3',{staticClass:"red--text mt-12 mb-12"},[_c('v-icon',{staticClass:"red--text mr-1"},[_vm._v("mdi-close")]),_c('div',[_vm._v(_vm._s(_vm.$t('a')))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }